
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 1C5.476 1 1 5.476 1 11s4.476 10 10 10 10-4.476 10-10S16.524 1 11 1zm5.806 11.129a.485.485 0 01-.483.484h-3.71v3.71a.485.485 0 01-.484.483H9.871a.485.485 0 01-.484-.483v-3.71h-3.71a.485.485 0 01-.483-.484V9.871c0-.266.217-.484.483-.484h3.71v-3.71c0-.266.218-.483.484-.483h2.258c.266 0 .484.217.484.483v3.71h3.71c.266 0 .483.218.483.484v2.258z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_incluir_proposta.svg